export default __webpack_public_path__ + "static/media/ic24_fct_WhatsApp.8bd3a7a3.svg";